<template>
  <div>
    <p v-html="$t('rc_pause_flow_paused_info')" class="tw:mb-8" />
    <p class="tw:font-bold">{{ $t('rc_pause_flow_feedback_header') }}</p>
    <p class="tw:text-sm tw:mb-1 tw:text-gray-700" v-html="$t('rc_pause_flow_feedback_subtext')" />
    <textarea
      data-testid="rc-pause-feedback"
      class="tw:outline-hidden tw:w-full tw:border tw:border-gray-500 tw:rounded-md tw:p-2 tw:max-h-[150px]"
      :placeholder="$t('rc_pause_flow_feedback_text_prompt')"
      @input="setFeedback($event.target.value)"
      :value="feedback"
      style="height: 56px"
    />
  </div>
</template>
<script setup>
defineProps({
  reasonId: Number,
  feedback: String,
})

const emit = defineEmits(['setFeedback'])
const setFeedback = text => emit('setFeedback', text)
</script>
